"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.formatNameToStringId = function (e) {
  return e.toLowerCase().trim().replace(/\//g, ' ') //  "/""
  .normalize('NFD') // ascentos y caracteres de ese tipo
  .replace(/[\u0300-\u036f]/g, '').replace(/([!#$%&‘()*+,/:;=?@[\]])/g, '') // elimina caracteres especiales
  .replace(/\s+/g, ' ') // espacios adyacentes
  .replace(/(\s)/g, '-') // espacios por "-""
  .replace(/-+/g, '-') // guiones adyacentes
  // eslint-disable-next-line no-control-regex
  .replace(/(?![\x00-\x7F])./g, '') // si llegaron caracteres "no ascii" hasta aqui los eliminamos
  ;
};